/**
 * Наложения, включённые при открытии любого раздела.
 *
 * Решение владельца 2026-08-07: землетрясения, фаза Луны и ледовая обстановка
 * должны быть видны сразу, без ручного включения.
 *
 * Тонкость, из-за которой это не просто «поставить true»: набор наложений живёт
 * в ссылке. Умолчание применяется ТОЛЬКО когда ключа `overlays` в ссылке нет
 * (холодный вход). Ссылка с пустым ключом (`overlays=`) — это «я их выключил», и
 * оживлять их нельзя: иначе пересланная ссылка перестанет воспроизводить вид.
 * Тот же приём, что у сида вида/флота в «Моделях» (modelsSectionSeed).
 */
export const DEFAULT_OVERLAYS = ['earthquakes', 'moon', 'ice']

export function seedOverlays(params: URLSearchParams): string[] {
  const raw = params.get('overlays')
  if (raw === null) return [...DEFAULT_OVERLAYS]
  return raw ? raw.split(',').filter(Boolean) : []
}
